// If this number is a decimal, make it just five decimal places
// to avoid exponents
var sanitize = function sanitize(v) {
  return Math.round(v * 100000) / 100000;
};

export { sanitize };